// extracted by css-extract-rspack-plugin
var _1 = "src-components-Base-Page-Page-module__centered-nC3oV7";
var _2 = "src-components-Base-Page-Page-module__page-ZChuSR";
export { _1 as "centered", _2 as "page" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"centered\":\"src-components-Base-Page-Page-module__centered-nC3oV7\",\"page\":\"src-components-Base-Page-Page-module__page-ZChuSR\"}";
        // 1752373455109
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  